import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { RequestDto } from './dto/RequestDto';
export type { RequestDto } from './dto/RequestDto';

/**
 * Смена тарифа/пакета
 * https://master.api-profile.sandbox.d2c.r-one.io/docs/v1#/Tariffs/bae45717eb8c85efb15fcf08b59e99f3
 * */
export const changePlanWebcab = (body: RequestDto): IRequest => ({
    uri: '/v1/change-tariff/change-plan-webcab',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(body),
});
